import moment from 'moment-timezone';

import { urls } from './../../config';
import authFetch from './../../utils/authFetch';

import { ordersAddList } from './../orders/actions';

export const ORDERS_COMPLETE_REQUEST = 'ORDERS_COMPLETE_REQUEST';
export const ORDERS_COMPLETE_RECEIVE = 'ORDERS_COMPLETE_RECEIVE';

export const ORDERS_COMPLETE_SET_SORTING = 'ORDERS_COMPLETE_SET_SORTING';
export const ORDERS_COMPLETE_SET_FILTER_TIME = 'ORDERS_COMPLETE_SET_FILTER_TIME';
export const ORDERS_FIND_SET_FILTER_SEARCH = 'ORDERS_FIND_SET_FILTER_SEARCH';

const ordersCompleteRequest = () => ({
    type: ORDERS_COMPLETE_REQUEST
});

const ordersCompleteReceive = numbers => ({
    type: ORDERS_COMPLETE_RECEIVE,
    numbers
});

const ordersCompleteFetch = () => {
    return dispatch => {
        dispatch(ordersCompleteRequest());
        return authFetch(urls.orders + '?folder=completed').then(json => {
            const numbers = json.results.map(order => order.number);
            const items = json.results.reduce((result, item) => {
                item.didInvalidate = true;
                result[item.number] = item;
                return result;
            }, {});
            dispatch(ordersAddList(items));
            dispatch(ordersCompleteReceive(numbers));
        });
    };
};

const ordersCompleteShouldFetch = state => {
    const ordersComplete = state.ordersComplete;
    if (ordersComplete.isFetching) {
        return false;
    }
    if (ordersComplete.updatedAt && moment().diff(ordersComplete.updatedAt, 'minutes') > 1) {
        return true;
    }
    return ordersComplete.didInvalidate;
};

export const ordersCompleteFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (ordersCompleteShouldFetch(getState())) {
            return dispatch(ordersCompleteFetch());
        }
    };
};

export const ordersCompleteSetSorting = value => {
    return {
        type: ORDERS_COMPLETE_SET_SORTING,
        value
    };
};

export const ordersCompleteSetFilterTime = value => {
    return {
        type: ORDERS_COMPLETE_SET_FILTER_TIME,
        value
    }
};

export const ordersCompleteSetFilterSearch = (value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_SEARCH,
        value
    }
};



// WEBPACK FOOTER //
// ./src/store/ordersComplete/actions.js